import { render, staticRenderFns } from "./MariaCards.vue?vue&type=template&id=d4fb664e"
import script from "./MariaCards.vue?vue&type=script&lang=js"
export * from "./MariaCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports